import(/* webpackMode: "eager" */ "/vercel/path0/src/app/page.tsx");
